var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',{staticClass:"mb-3 pb-3 border-bottom"},[_c('strong',{domProps:{"textContent":_vm._s(_vm.$lang.reportCharacterLabel)}})]),_c('ChartLineProgress',{attrs:{"data":_vm.azmoonExecutePersonData}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }